import React from 'react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle
} from '../../ui/sheet';
import { Button } from '../../ui/button';
import { Summary } from './Summary';
import { getUnsatisfiedChoiceGroups } from '../../../utils/choiceGroups';
import { Section } from './Section';

const AssignmentDrawer = (props) => {
  const {
    studentResponse,
    isReview,
    assignmentQuestionSections,
    assignmentQuestions,
    isOpen,
    onClose,
    onEndTest,
    isEndAssignmentLoading
  } = props;

  // Questions come along as well as sections: a group may hold a whole reading comprehension
  // block, and answering into that block is what counts as attempting it.
  const shortChoiceGroups = getUnsatisfiedChoiceGroups(
    { sections: assignmentQuestionSections, questions: assignmentQuestions },
    studentResponse
  );

  if (!studentResponse) {
    return null;
  }

  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
      <SheetContent side="right" className="flex w-full flex-col p-0 sm:max-w-sm">
        <SheetHeader className="flex-shrink-0 border-b border-border/50 p-4">
          <SheetTitle>Question Navigation</SheetTitle>
          <SheetDescription>Track your progress and jump to any question.</SheetDescription>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto px-4 py-4">
          <Summary studentResponse={studentResponse} />
          <Section
            id={1}
            questions={studentResponse}
            closeDrawer={onClose}
            isReview={isReview}
            assignmentQuestionSections={assignmentQuestionSections}
            assignmentQuestions={assignmentQuestions}
          />
        </div>

        {!isReview && onEndTest && (
          <div className="flex-shrink-0 border-t border-border/50 p-4">
            {/* Submitting here skips the confirmation the End Test button shows, so any
                choice group still short of its required count is called out inline. */}
            {shortChoiceGroups.length > 0 && (
              <div className="mb-3 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900">
                {shortChoiceGroups.map(({ group, progress }) => (
                  <div key={group.id}>
                    Attempt any {progress.requiredCount} of {progress.total} —{' '}
                    {progress.remaining} still to answer
                  </div>
                ))}
              </div>
            )}
            <Button
              type="button"
              variant="destructive"
              className="w-full"
              onClick={onEndTest}
              disabled={isEndAssignmentLoading}
            >
              Submit Test
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};

export { AssignmentDrawer };
